import React from 'react';
import './PrivacyPolicyPage.css';

function PrivacyPolicyPageEnLite() {
    return (
        <div className="privacy-policy-container">
        <h1>Tasbih Dhikr Lite Privacy Policy</h1>
        <p>Last Updated: January 31, 2024</p>
  
        <h2>Introduction</h2>
        <p>Welcome to the Tasbih Dhikr Lite app. This privacy policy is intended to inform you about how we handle your data when you use our application. The only data collection in this app is carried out by AdMob, a Google advertising service, and we do not actively collect any personal data.</p>
  
        <h2>1. Collection and Use of Your Personal Data</h2>
        <h3>a. Types of Data Collected</h3>
        <h4>i. Data Usage via AdMob</h4>
        <p>Our app uses AdMob to display advertisements. AdMob may collect data such as your IP address, your device identifier, and information about your use of the app. These details are used to provide and improve the advertising experience.</p>
  
        <h3>b. Use of Data</h3>
        <p>The data collected by AdMob is used for:</p>
        <ul>
          <li>Providing and personalizing advertisements within the app.</li>
          <li>Analyzing the effectiveness of the advertisements displayed.</li>
        </ul>
  
        <h3>c. User Control</h3>
        <p>You can control the use of your data for personalized advertising through your device settings.</p>
  
        <h2>2. Transfer of Data</h2>
        <p>Your information may be transferred to and maintained on computers located outside of your state, province, or country where data protection laws may differ.</p>
  
        <h2>3. Disclosure of Your Personal Data</h2>
        <p>Data collected by AdMob may be shared in accordance with Google's privacy policy and legal requirements.</p>
  
        <h2>4. Security of Your Personal Data</h2>
        <p>The security of your data is important to us. However, no method of transmission over the Internet or electronic storage is 100% secure.</p>
  
        <h2>5. Links to Other Sites</h2>
        <p>Our service may contain links to other sites. If you click on a third-party link, you will be directed to that third party's site.</p>
  
        <h2>6. Changes to This Privacy Policy</h2>
        <p>We may update our privacy policy from time to time. We will notify you of any changes by posting the new privacy policy on this page.</p>
  
        <h2>7. Contact Us</h2>
        <p>If you have any questions about this privacy policy, please contact us.</p>
  
        <h2>Useful Links</h2>
        <p><a href="https://policies.google.com/privacy">Google's Privacy Policy</a></p>
      </div>
    );
}

export default PrivacyPolicyPageEnLite;
